import { defineMessages } from 'react-intl';

export default defineMessages({
  metaTitle: {
    id: 'global_meta_title',
    defaultMessage: 'Properties to rent and for sale - Trovit',
  },
  metaDescription: {
    id: 'global_meta_description',
    defaultMessage:
      'Your search engine for property listings. Find houses, flats, studios, townhouses, land, flatshares, holiday homes for sale and to rent.',
  },
  metaTitleNoLocation: {
    id: 'global_meta_title_location_no_region',
    defaultMessage: 'The search engine for {%1$s} {%2$s} - Trovit',
  },
  metaDescriptionNoLocation: {
    id: 'global_meta_description_location_no_region',
    defaultMessage:
      "Find in seconds your ideal {%1$s} for {%2$s}. In Trovit you'll be able to find any {%1$s} for {%2$s} from different property websites",
  },
  genericPropertyType: {
    id: 'global_generic_property_type',
    defaultMessage: 'property',
  },
  genericPropertyTypePlural: {
    id: 'global_viviendas',
    defaultMessage: 'property',
  },
  homepageMetaTitle: {
    id: 'global_homepage_meta_title',
    defaultMessage: 'Find all kinds of used products for sale, great deals and offers',
  },
  searchSlogan: {
    id: 'global_search_slogan',
    defaultMessage: 'Ads from thousands of websites in just one search',
  },
  searchPlaceholder: {
    id: 'global_search_placeholder',
    defaultMessage: 'Search by Neighbourhood, City or Address',
  },
  searchWherePlaceholder: {
    id: 'global_wm_placeholder_where',
    defaultMessage: 'City or county',
  },
  buscar: {
    id: 'global_buscar',
    defaultMessage: 'Search',
  },
  noResults: {
    id: 'global_no_results_generic',
    defaultMessage: 'No results were found',
  },
  makeSubtitle: {
    id: 'global_hierarchy_linking_by_make',
    defaultMessage: 'Second-hand cars by make:',
    description: 'cars',
  },
  regionSubtitle: {
    id: 'global_hierarchy_linking_by_region',
    defaultMessage: 'Second-hand cars in:',
    description: 'cars',
  },
  sourceSlogan: {
    id: 'global_home_uvp_description',
    defaultMessage:
      'Trovit collaborates with thousands of websites to help you find what you are looking for.',
  },
});



// WEBPACK FOOTER //
// ./app/Index/messages.js